import { MappingInfo } from '../../interfaces/Mapping';
import { Template } from '../../interfaces/Templates';
import { AdvancedOptions } from './../../interfaces/Mapping';

export const isFileIsCompatible = (mappedColumns: MappingInfo[], templateColumns: MappingInfo[]): boolean => {
	const templateMappedColumns = templateColumns.filter(templateColumn => templateColumn.targetField !== '');
	return !templateMappedColumns.some(
 		templateColumn => !mappedColumns.some(mappedColumn => mappedColumn.sourceField.toUpperCase() === templateColumn.sourceField.toUpperCase())
	);
};

export const isTwoMappingColumnsEqual = (
	mappingColumnsLocal: MappingInfo[],
	mappingColumnsFetched: MappingInfo[]
): boolean => {
	const cloneMappingColumnsLocal = [...mappingColumnsLocal.map(object => ({ ...object }))];
	const cloneMappingColumnsFetched = [...mappingColumnsFetched.map(object => ({ ...object }))];
	if (cloneMappingColumnsFetched.length === 0) return false;
	for (let index = 0; index < cloneMappingColumnsLocal.length; index++) {
		const local = cloneMappingColumnsLocal[index];
		const isColumnOnlyInFile = cloneMappingColumnsFetched.find(fetched => fetched.sourceField === local.sourceField);
		if (isColumnOnlyInFile === undefined && local.targetField !== '') return false;
		for (let m = 0; m < cloneMappingColumnsFetched.length; m++) {
			const fetched = cloneMappingColumnsFetched[m];
			if (fetched.sourceField === local.sourceField && fetched.targetField !== local.targetField) {
				return false;
			}
		}
	}
	return true;
};

const isShadowEqual = (value1: string | number | null, value2: string | number | null): boolean => {
	const tempVal1 = value1 === null ? '' : value1;
	const tempVal2 = value2 === null ? '' : value2;
	return tempVal1.toString() === tempVal2.toString();
};

export const isTwoAdvancedOptionsEqual = (templateFetched: Template, templateInfo: AdvancedOptions): boolean =>
	isShadowEqual(templateFetched.dateFormat!, templateInfo.dateFormat) &&
	isShadowEqual(templateFetched.decimalSymbol!, templateInfo.decimalSymbol) &&
	isShadowEqual(templateFetched.thousandSeparator!, templateInfo.thousandSeparator) &&
	isShadowEqual(templateFetched.calculationType!, templateInfo.calculationType) &&
	isShadowEqual(templateFetched.transactionType!, templateInfo.transactionType);
